import React from 'react';
import styles from './index.module.scss';

export default function Screen4() {
  return (
    <section className={styles['screen4-cover']}>
      <div className={styles['screen4-wrap']}>
        {/* 左侧文案 */}
        <div className={styles['screen4-left']}></div>

        {/* 右侧卡片 */}
        <div className={styles['screen4-card']}>
          <div className={styles['screen4-item']}>
            <div className={`${styles['screen4-item-content']} ${styles['screen4-item-content1']}`}>
              <div className={styles['screen4-item-title']}>使命</div>
              <div className={styles['screen4-item-desc']}>爱与AI帮助每个人成为更好的自己</div>
            </div>
          </div>

          <div className={styles['screen4-item']}>
            <div className={`${styles['screen4-item-content']} ${styles['screen4-item-content2']}`}>
              <div className={styles['screen4-item-title']}>愿景</div>
              <div className={styles['screen4-item-desc']}>成为人人信赖的成长伙伴</div>
            </div>
          </div>

          <div className={styles['screen4-item']}>
            <div className={`${styles['screen4-item-content']} ${styles['screen4-item-content3']}`}>
              <div className={styles['screen4-item-title']}>价值观</div>
              <div className={styles['screen4-item-desc']}>
                爱自己&nbsp;&nbsp;&nbsp;&nbsp;爱伙伴&nbsp;&nbsp;&nbsp;&nbsp;爱世界
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
